import {apiRegister} from '../../common/api'
import {forEach} from '../../utils/base'
import {KUser} from '../../models/k-user'

export const commentPost = apiRegister('commentPost', {
  protoId: 74,
  path: '/comment/post/'
}).send

export const commentList = apiRegister('commentList', {
  protoId: 75,
  path: '/comment/list/',
  formatResult({total, list, userInfos}) {
    userInfos = userInfos || []
    const userMap = {}
    forEach(userInfos, user => {
      userMap[user.uid] = KUser(user)
    })
    return {
      total,
      list,
      userMap
    }
  }
}).send
